import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PageHeader({ title, subtitle, right, backTo = "/" }) {
  return (
    <div className="max-w-xl mx-auto w-full px-4 pt-5 pb-2">
      <Link
        to={backTo}
        className="inline-flex items-center gap-1.5 text-sky-700 text-sm font-semibold hover:text-sky-900 transition-colors"
      >
        <ArrowLeft className="h-4 w-4" /> Back
      </Link>
      <div className="mt-3 flex items-start justify-between gap-4">
        <div>
          <h1 className="font-heading font-black text-slate-900 text-3xl sm:text-4xl tracking-tight">
            {title}
          </h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>
        {right}
      </div>
    </div>
  );
}
